/**
 * Offline Mode Composable
 *
 * Tracks browser online/offline state and provides reactive flags.
 * Components can use `isReadOnly` to disable editing when offline.
 */

import { ref, readonly, computed, onMounted, onUnmounted } from 'vue';

// Module-level singleton state
const isOffline = ref(!navigator.onLine);
let listenerCount = 0;

function handleOnline() {
  isOffline.value = false;
}

function handleOffline() {
  isOffline.value = true;
}

export function useOfflineMode() {
  onMounted(() => {
    if (listenerCount === 0) {
      window.addEventListener('online', handleOnline);
      window.addEventListener('offline', handleOffline);
    }
    listenerCount++;
    isOffline.value = !navigator.onLine;
  });

  onUnmounted(() => {
    listenerCount--;
    if (listenerCount === 0) {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    }
  });

  const isReadOnly = computed(() => isOffline.value);

  return {
    isOffline: readonly(isOffline),
    isReadOnly,
  };
}
